import Vue from 'vue';

Vue.filter('daysLeft', (value) => {
  const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
  return Math.round(Math.abs(Date.parse(value) - Date.now()) / (oneDay));
});

Vue.filter('price', (value) => {
  // An amount of money is stored on backend in the smallest sub-division of the currency, eg: 1$ = 100
  const price = value / 100;
  const val = (price / 1).toFixed(2).replace('.', ',');
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
});

Vue.filter('truncate', (string, value) => `${string.substring(0, value)}...`);

Vue.filter('currencySymbol', (value) => {
  switch (value) {
    case 'GBP': {
      return '£';
    }
    case 'USD': {
      return '$';
    }
    case 'EUR': {
      return '€';
    }
    case 'PLN': {
      return 'PLN';
    }
    default: {
      return '';
    }
  }
});



// WEBPACK FOOTER //
// ./src/filters.js